export enum OrderDeliveryTypeEnum {
    Courier = 'Courier',
    InShop = 'InShop',
    SelfDelivery = 'SelfDelivery',
}